module.exports = __webpack_public_path__ + "img/freespin_multiplier.a1d42bbe.png";